import { GET_SEARCHABLE_EMPLOYEES } from "../../../enums/Employees/employees.types";

export const getSearchableEmployeesAction = (employees) => {
    return {
        type: GET_SEARCHABLE_EMPLOYEES,
        payload: employees,
    };
};